export const MEDIA_QUERY_NAVIGATION_XLARGE_DESKTOP = `@media screen and (min-width: 1200px)`
export const MEDIA_QUERY_NAVIGATION_MEDIUM_DESKTOP = `@media screen and (min-width: 975px)`

export const HOVER_DELAY_MS = 200
export const MEDIA_QUERY_NAVIGATION_MEDIUM_DESKTOP_NUM = 975
